const AyudateSesion = {
	tokenPayload(){
		try{
			const token = localStorage.getItem('token')
			if(!token) return null
			const partes = token.split('.')
			if(partes.length !== 3) return null
			let b64 = partes[1].replace(/-/g, '+').replace(/_/g, '/')
			while(b64.length % 4) b64 += '='
			return JSON.parse(atob(b64))
		}catch(e){
			return null
		}
	},

	tokenExpirado(){
		const payload = this.tokenPayload()
		if(!payload || !payload.exp) return true
		return Date.now() >= payload.exp * 1000
	},

	verificarSesion(){
		let sesion = localStorage.getItem('id')
		if(!sesion) return false
		if(this.tokenExpirado()) return false
		return true
	},

	obtenerDatosSesion(){
		const id = localStorage.getItem('id')
		const usuario = localStorage.getItem('usuario')
		const nombre = localStorage.getItem('nombre')
		const grupoId = localStorage.getItem('grupoId')
		const grupoNombre = localStorage.getItem('grupoNombre')

		return {
			id: id,
			usuario: usuario,
			nombre: nombre,
			grupoId: grupoId ? parseInt(grupoId) : null,
			grupoNombre: grupoNombre
		}
	},

	establecerSesion(usuario){
		localStorage.setItem('id', usuario.id)
		localStorage.setItem('usuario', usuario.usuario)
		localStorage.setItem('nombre', usuario.nombre)
		localStorage.setItem('roles', JSON.stringify(usuario.roles || []))
		if(usuario.token) localStorage.setItem('token', usuario.token)
		if(usuario.grupoId) localStorage.setItem('grupoId', usuario.grupoId)
		if(usuario.grupoNombre) localStorage.setItem('grupoNombre', usuario.grupoNombre)
	},

	establecerDatosNegocio(datos){
		// Línea de seguridad para evitar bloqueos en el navegador
		if (!datos) return; 
		
		localStorage.setItem('nombreNegocio', datos.nombre)
		localStorage.setItem('telefonoNegocio', datos.telefono)
		localStorage.setItem('logoNegocio', datos.logo)
	},	

	obtenerDatosNegocio(){
		return {
			nombre: localStorage.getItem('nombreNegocio'),
			telefono: localStorage.getItem('telefonoNegocio'),
			logo: localStorage.getItem('logoNegocio')
		}
	},

	obtenerRolesSesion(){
		try{
			return JSON.parse(localStorage.getItem('roles') || '[]')
		} catch(e){
			return []
		}
	},

	esSuper(){
		const roles = this.obtenerRolesSesion()
		for(let r of roles) if(r.nombre && r.nombre.toUpperCase() === 'SUPER') return true
		return false
	},

	actuandoComoGrupo(){
		return !!localStorage.getItem('superActuandoComoGrupo')
	},

	// Permite salir del modo 'actuar como grupo'
	salirActuando(){
		localStorage.removeItem('grupoSeleccionado')
		localStorage.removeItem('grupoSeleccionadoNombre')
		localStorage.removeItem('grupoSeleccionadoJefe')
		localStorage.removeItem('superActuandoComoGrupo')
		window.dispatchEvent(new Event('grupoSeleccionadoChanged'))
	},

	cerrarSesion(){
		localStorage.removeItem('id')
		localStorage.removeItem('usuario')
		localStorage.removeItem('nombre')
		localStorage.removeItem('grupoId')
		localStorage.removeItem('grupoNombre')
		localStorage.removeItem('token')
		localStorage.removeItem('roles')
		localStorage.removeItem('grupoSeleccionado')
		localStorage.removeItem('grupoSeleccionadoNombre')
		localStorage.removeItem('grupoSeleccionadoJefe')
		localStorage.removeItem('superActuandoComoGrupo')
		location.reload()
	}
}

export default AyudateSesion
